import { useState } from "react";
import { Col, Modal } from "react-bootstrap";
import toast, { Toaster } from "react-hot-toast";
import { useSelector } from "react-redux";
import { Encryptedid } from "../../Util/BcruptEncyptid";
import { isTrialEndedReadOnly, sendVideoShareApi } from "../../Util/HelperFunction";

const ShareVideo = ({ data, shortContainerRef, fullscreenState }) => {
  const [showModal, setShowModal] = useState(false);
  const [copiedStates, setCopiedStates] = useState({});
  const userData = useSelector((state) => state?.authSlice.userData?.payload);
  const schoolData = useSelector((state) => state?.authSlice?.schoolDetail);
  const isReadOnly = isTrialEndedReadOnly(schoolData, userData);

  const encryptedId = data?.categoryId?._id
    ? Encryptedid(data.categoryId._id)
    : "";


  const copyToClipboard = async (url, key) => {
    if (data) {
      sendVideoShareApi(data).catch((error) => {
        console.error("Error sharing video:", error);
      });
    }

    const setSuccess = () => {
      setCopiedStates((prev) => ({ ...prev, [key]: true }));
      setTimeout(
        () => setCopiedStates((prev) => ({ ...prev, [key]: false })),
        2000
      );
      toast.success("URL copied to clipboard!", {
        container: shortContainerRef?.current,
      });
    };

    const fallbackCopy = () => {
      try {
        const textarea = document.createElement("textarea");
        textarea.value = url;
        textarea.style.position = "fixed";
        textarea.style.top = "0";
        textarea.style.left = "0";
        textarea.style.opacity = "0";
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        const successful = document.execCommand("copy");
        document.body.removeChild(textarea);
        if (successful) {
          setSuccess();
        } else {
          toast.error("Failed to copy URL.", {
            container: shortContainerRef?.current,
          });
        }
      } catch (err) {
        console.error("Fallback copy error:", err);
        toast.error("Failed to copy URL.", {
          container: shortContainerRef?.current,
        });
      }
    };

    if (navigator.clipboard && window.isSecureContext) {
      try {
        await navigator.clipboard.writeText(url);
        setSuccess();
      } catch (err) {
        console.warn("navigator.clipboard failed, trying fallback:", err);
        fallbackCopy();
      }
    } else {
      fallbackCopy();
    }
  };

  return (
    <>
      <Col className="btns-main" ref={shortContainerRef?.current}>
        <button
          className="download-cover view-reels-side-btn"
          onClick={() => !isReadOnly && setShowModal(true)}
          disabled={isReadOnly}
          style={isReadOnly ? { opacity: 0.5, cursor: "not-allowed" } : {}}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="26"
            viewBox="0 0 20 26"
            fill="none"
          >
            <path
              d="M13.8473 17.0668V21.2846V23.1789C13.8473 23.8086 13.3349 24.3228 12.6996 24.3228H1.89028C1.25894 24.3228 0.75 23.8123 0.75 23.1789V7.30021C0.75 6.66635 1.25881 6.15601 1.89028 6.15601H3.78795H11.2L11.9496 8.68625C11.9496 8.69398 11.9495 8.70177 11.9495 8.70961C11.949 9.71316 11.948 11.6454 12.1771 13.3624C12.2959 14.253 12.4839 15.1487 12.7992 15.8414C13.009 16.3025 13.3412 16.8062 13.8473 17.0668Z"
              stroke="#6475E0"
              strokeWidth="1.5"
            />
            <path
              d="M19.7337 6.23081L19.7336 6.23084L19.7362 6.23331C19.7731 6.26839 19.8021 6.31078 19.8216 6.35775L19.9602 6.30026L19.8216 6.35775C19.8411 6.40472 19.8506 6.45524 19.8494 6.50608L19.8494 6.50608V6.50952V17.7729C19.8494 18.735 19.0677 19.5171 18.1017 19.5171H7.2961C6.32992 19.5171 5.54844 18.735 5.54844 17.7729V1.89396C5.54844 0.932097 6.3299 0.150022 7.2961 0.150022L13.4898 0.150029L13.4912 0.150016C13.5418 0.149546 13.5921 0.159403 13.6388 0.178983C13.6855 0.198564 13.7278 0.227459 13.763 0.263905L13.763 0.263921L13.7649 0.265798L19.7337 6.23081Z"
              fill="#6475E0"
              stroke="#6475E0"
              strokeWidth="0.3"
            />
          </svg>
        </button>
        <p>Share via Link</p>
        {shortContainerRef?.current && fullscreenState && (
          <Toaster container={shortContainerRef?.current} />
        )}
      </Col>

      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title className="fw-bold fs-4">Share Video</Modal.Title>
        </Modal.Header>
        <Modal.Body className="pt-3">
          {[
            {
              role: "Teachers",
              bgColor: "#d200a5",
              icon: (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  id="School-Fill--Streamline-Outlined-Fill-Material"
                  height="20"
                  width="24"
                >
                  <desc>
                    School Fill Streamline Icon: https://streamlinehq.com
                  </desc>
                  <path
                    fill="#ffff"
                    d="M21.5 16.925v-7.05L11.975 15 1 9 11.975 3 23 9v7.925h-1.5ZM11.975 21l-7.25 -3.975v-5.25l7.25 3.975 7.25 -3.975v5.25L11.975 21Z"
                    strokeWidth="0.5"
                  />
                </svg>
              ),
              key: "teacher",
            },
            {
              role: "Learners",
              bgColor: "#d200a5",
              icon: (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  id="Person-Raised-Hand--Streamline-Rounded-Material"
                  height="20"
                  width="24"
                >
                  <desc>
                    Person Raised Hand Streamline Icon: https://streamlinehq.com
                  </desc>
                  <path
                    fill="#ffff"
                    d="M2.75 22.9999c-0.2125 0 -0.390585 -0.07235 -0.53425 -0.217 -0.143835 -0.1445 -0.21575 -0.32365 -0.21575 -0.5375 0 -0.21365 0.071915 -0.39135 0.21575 -0.533 0.143665 -0.14165 0.32175 -0.2125 0.53425 -0.2125h18.5c0.2125 0 0.39065 0.07235 0.5345 0.217 0.14365 0.1445 0.2155 0.32365 0.2155 0.5375 0 0.21365 -0.07185 0.39135 -0.2155 0.533 -0.14385 0.14165 -0.322 0.2125 -0.5345 0.2125h-18.5Zm2 -3c-0.2125 0 -0.390585 -0.0719 -0.53425 -0.21575C4.071915 19.6405 4 19.4624 4 19.2499v-4.5c-0.65 -1.51665 -1.1 -2.74585 -1.35 -3.6875 -0.25 -0.94165 -0.375 -1.8875 -0.375 -2.8375 0 -0.96665 0.120835 -1.98335 0.3625 -3.05 0.241665 -1.066665 0.579165 -2.075 1.0125 -3.025 0.166665 -0.366665 0.387085 -0.64583 0.66125 -0.8375 0.274165 -0.191665 0.57875 -0.2875 0.91375 -0.2875 0.45 0 0.79165 0.145835 1.025 0.4375 0.23335 0.29167 0.35 0.72917 0.35 1.3125v3.275c0 0.73335 0.14165 1.425 0.425 2.075 0.28335 0.65 0.67085 1.21665 1.1625 1.7 0.49165 0.48335 1.06075 0.8625 1.70725 1.1375 0.6465 0.275 1.34825 0.4125 2.10525 0.4125 1.35 0 2.525 0.1 3.525 0.3 1 0.2 1.83335 0.49165 2.5 0.875s1.1625 0.87085 1.4875 1.4625c0.325 0.59165 0.4875 1.2875 0.4875 2.0875v3.15c0 0.2125 -0.07185 0.3906 -0.2155 0.53425 -0.14385 0.14385 -0.322 0.21575 -0.5345 0.21575h-14.5Zm0.75 -1.5h13v-2.4c0 -0.55 -0.13335 -1.025 -0.4 -1.425 -0.26665 -0.4 -0.66665 -0.73335 -1.2 -1 -0.53335 -0.26665 -1.20835 -0.46665 -2.025 -0.6 -0.81665 -0.13335 -1.775 -0.2 -2.875 -0.2 -0.95 0 -1.84585 -0.17915 -2.6875 -0.5375 -0.84165 -0.35835 -1.575 -0.84585 -2.2 -1.4625 -0.625 -0.61665 -1.12085 -1.34165 -1.4875 -2.175 -0.36665 -0.83335 -0.55 -1.725 -0.55 -2.675v-3.25c-0.383335 0.75 -0.695835 1.620835 -0.9375 2.6125 -0.241665 0.99165 -0.3625 1.9375 -0.3625 2.8375 0 0.85 0.129165 1.72915 0.3875 2.6375 0.258335 0.90835 0.704165 2.0625 1.3375 3.4625v4.175Zm6.5 -8.5c-1.1 0 -2.04165 -0.39165 -2.825 -1.175s-1.175 -1.725 -1.175 -2.825 0.39165 -2.041665 1.175 -2.825c0.78335 -0.78333 1.725 -1.175 2.825 -1.175s2.04165 0.39167 2.825 1.175c0.78335 0.783335 1.175 1.725 1.175 2.825s-0.39165 2.04165 -1.175 2.825 -1.725 1.175 -2.825 1.175Zm0 -1.5c0.7 0 1.29165 -0.24165 1.775 -0.725 0.48335 -0.48335 0.725 -1.075 0.725 -1.775s-0.24165 -1.291665 -0.725 -1.775c-0.48335 -0.48333 -1.075 -0.725 -1.775 -0.725s-1.29165 0.24167 -1.775 0.725c-0.48335 0.483335 -0.725 1.075 -0.725 1.775s0.24165 1.29165 0.725 1.775c0.48335 0.48335 1.075 0.725 1.775 0.725Zm-3.75 11.5v-0.925c0 -1.05 0.36325 -1.95 1.08975 -2.7 0.72665 -0.75 1.6134 -1.125 2.66025 -1.125h3c0.2125 0 0.39065 0.07235 0.5345 0.217 0.14365 0.1445 0.2155 0.32365 0.2155 0.5375 0 0.21365 -0.07185 0.39135 -0.2155 0.533 -0.14385 0.14165 -0.322 0.2125 -0.5345 0.2125h-3c-0.6375 0 -1.17185 0.22875 -1.603 0.68625 -0.43135 0.4575 -0.647 1.00375 -0.647 1.63875v0.925h-1.5Z"
                    strokeWidth="0.5"
                  />
                </svg>
              ),
              key: "student",
            },
          ].map(({ role, bgColor, icon, key }) => {
            const url = `${process.env.REACT_APP_SHARED_URL}video-shorts/${encryptedId}/${data?._id}?isShareable=true&role=${key}`;
            const isCopied = copiedStates[key];

            const lightenColor = (color) => {
              const amt = 100;
              let usePound = false;

              if (color[0] === "#") {
                color = color.slice(1);
                usePound = true;
              }

              const num = parseInt(color, 16);

              let r = (num >> 16) + amt;
              if (r > 255) r = 255;

              let g = ((num >> 8) & 0x00ff) + amt;
              if (g > 255) g = 255;

              let b = (num & 0x0000ff) + amt;
              if (b > 255) b = 255;

              return (
                (usePound ? "#" : "") +
                r.toString(16).padStart(2, "0") +
                g.toString(16).padStart(2, "0") +
                b.toString(16).padStart(2, "0")
              );
            };

            const outlineColor = lightenColor(bgColor);

            return (
              <section key={key} className="mb-4">
                <header className="d-flex align-items-center mb-2">
                  <div
                    className="rounded-circle text-white d-flex align-items-center justify-content-center me-2"
                    style={{ backgroundColor: bgColor, width: 28, height: 28 }}
                    aria-hidden="true"
                  >
                    {icon}
                  </div>
                  <h6 className="mb-0 fw-semibold">{`Share Link with ${role}`}</h6>
                </header>
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control border-end-0"
                    value={url.slice(0, 45) + (url.length > 45 ? "..." : "")}
                    readOnly
                    aria-label={`Shareable link for ${role}`}
                    style={{ backgroundColor: "#f8f9fa" }}
                  />
                  <button
                    type="button"
                    className="px-3"
                    onClick={() => copyToClipboard(url, key)}
                    style={{
                      minWidth: 90,
                      backgroundColor: isCopied ? bgColor : "transparent",
                      border: `2px solid ${isCopied ? bgColor : outlineColor}`,
                      color: isCopied ? "#fff" : bgColor,
                      borderRadius: 4,
                      fontWeight: "600",
                      transition: "all 0.3s ease",
                    }}
                    aria-live="polite"
                    aria-pressed={isCopied}
                    aria-label={
                      isCopied ? `${role} link copied` : `Copy ${role} link`
                    }
                  >
                    {isCopied ? "✓ Copied" : "share via link"}
                  </button>
                </div>
              </section>
            );
          })}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ShareVideo;
